import { Grid, Paper } from "@mantine/core";
import React from "react";
import External from "../components/integrations/external";
import AppData from "../components/integrations/app_data";

export default function Integrations(){
    return <div style={{position: 'relative'}}>
        <Grid>
            <Grid.Col sm={12} md={6}>
                <Paper p="md" shadow="md">
                    <AppData />
                </Paper>
            </Grid.Col>
            <Grid.Col sm={12} md={6}>
                <Paper p="md" shadow="md">
                    <External />
                </Paper>
            </Grid.Col>
        </Grid>
    </div>
}
